import React from 'react';
import { FreePlayDiceRollDialog } from '@colonist/clientforge';
import { MatchmakingMatchTypes } from '@colonist/game-base-types';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { getHomepageUrlWithParameter, navigateToPage } from '../ui_utils/ClientUtils.ts';
import { UIUrlParameterNames } from '../ui_html/UIUrlController.ts';
export const FreePlayDiceRollDialogContainer = ({ open, onClose, eligibleRolls })=>{
    const handleRoll = async ()=>{
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiFreePlayDiceRoll(), undefined, undefined);
        if (response == undefined) return undefined;
        const data = response.json;
        const roll = data.diceRoll;
        if (roll == undefined) return undefined;
        return {
            roll: roll,
            isWinningRoll: eligibleRolls.includes(roll)
        };
    };
    const handlePlayRanked = ()=>{
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterMatchmaking, MatchmakingMatchTypes.RankedCitiesAndKnights4P));
    };
    return /*#__PURE__*/ React.createElement(FreePlayDiceRollDialog, {
        open: open,
        onClose: onClose,
        eligibleRolls: eligibleRolls,
        onRoll: handleRoll,
        onPlayRanked: handlePlayRanked
    });
};
